import { render, staticRenderFns } from "./DrvColumnsModal.vue?vue&type=template&id=d2492526"
import script from "./DrvColumnsModal.vue?vue&type=script&lang=js"
export * from "./DrvColumnsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports